export default __webpack_public_path__ + "assets/7.3acb15cc.png";